import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { TssCacheProvider } from "tss-react";
import { FeatureFlagProvider } from "@miplatform/feature-flags";
import { AppInsightsProvider, GoogleMapsProvider } from "@miplatform/providers";
import { createTheme } from "@miplatform/theme";
import { history } from "@miplatform/utils";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import {
  ReactPlugin,
  withAITracking,
} from "@microsoft/applicationinsights-react-js";
import { ThemeProvider } from "@mui/material/styles";
import { GlobalManagerApprovalProvider } from "./components/GlobalManagerApprovalProvider/GlobalManagerApprovalProvider";
import { AuthWrapper } from "./AuthWrapper";
import { AuthorizedRoutes } from "./AuthorizedRoutes";

const appInsightsReactPlugin = new ReactPlugin();

function App({ authConfig }) {
  const theme = createTheme();

  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      return;
    }
    meta.setAttribute("content", theme.palette.primary.main);
  }, [theme.palette.primary.main]);

  const muiCache = createCache({
    key: "mui",
    prepend: true,
  });

  const tssCache = createCache({
    key: "tss",
  });

  return (
    <AppInsightsProvider reactPlugin={appInsightsReactPlugin} history={history}>
      <AuthWrapper authConfig={authConfig}>
        <CacheProvider value={muiCache}>
          <TssCacheProvider value={tssCache}>
            <ThemeProvider theme={theme}>
              <GoogleMapsProvider>
                <GlobalManagerApprovalProvider>
                  <FeatureFlagProvider>
                    <Toaster />
                    <AuthorizedRoutes />
                  </FeatureFlagProvider>
                </GlobalManagerApprovalProvider>
              </GoogleMapsProvider>
            </ThemeProvider>
          </TssCacheProvider>
        </CacheProvider>
      </AuthWrapper>
    </AppInsightsProvider>
  );
}

export default withAITracking(appInsightsReactPlugin, App, "MIVIEW WEB");
